// The register's narrow presentation: one tile per counterparty, the name first, the same sort
// control the deal tiles use so a sort survives a rotation from tiles to table.

import { Link } from 'react-router';

import TileSort from '../ui/TileSort.jsx';
import { categories, commodities, country, rating, status } from './cells.jsx';
import { SORTABLE_COLUMNS } from './counterpartyUrl.js';

export default function CounterpartyTiles({ rows, products, query, onSort }) {
  return (
    <>
      <TileSort options={SORTABLE_COLUMNS} query={query} onSort={onSort} />

      <ul className="deal-tiles">
        {rows.map((record) => (
          <li key={record.counterparty_id} className="deal-tile">
            <div className="deal-tile-head">
              <Link to={`/counterparties/${record.counterparty_id}`}>{record.name}</Link>
              {status(record)}
            </div>

            <dl className="deal-tile-fields">
              <Field label="Categories">{categories(record)}</Field>
              <Field label="Commodities">{commodities(record, products)}</Field>
              <Field label="Rating">{rating(record)}</Field>
              {record.country && <Field label="Country">{country(record)}</Field>}
              {record.created_by && <Field label="Added by">{record.created_by}</Field>}
            </dl>
          </li>
        ))}
      </ul>
    </>
  );
}

function Field({ label, children }) {
  return (
    <>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </>
  );
}
